import i18n from '@/i18n';
import store from '@/store/store';
import * as api from '@/api/besoin';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import * as devisConf from '@/configuration/devisConf';
import * as produitConf from '@/configuration/catalogue/produitConf';
import genererGuid from '@/services/general/genererGuid';

export const CATEGORIES_REGROUPEMENT = [
  produitConf.CATEGORIE_REGROUPEMENT,
  produitConf.CATEGORIE_REGROUPEMENT_LC,
  produitConf.CATEGORIE_REGROUPEMENT_MAIRIE,
];

export function besoinIsNotModifiable(besoin) {
  return !!besoin.commandeAchatId;
}
export function besoinIsNotDeletableMsg(besoin) {
  const msg = [];
  if (besoin.commandeAchatId) {
    msg.push(i18n.t('editionCommande.logistiqueImpression.affiches.besionCannotBeRemoved'));
  }
  return msg.join(', ');
}

export function checkIfLigneCanBeDeletedWithBesoin(ligne, commande) {
  if (!commande.besoins?.length) return true;

  const isRegroupement = ligne.type === devisConf.REGROUPEMENT;
  const isProduitRegroupement = CATEGORIES_REGROUPEMENT.includes(ligne.typeProduit);
  if (!isProduitRegroupement || !isRegroupement) return true;

  const hasBesoin = commande.besoins.some(b => {
    return b.produitId === ligne.produitId
      && b.anneeSemaineDepart === ligne.ligneReseau.anneeSemaine;
  });

  return !hasBesoin;
}

export function checkIfLignesCanBeDeletedWithBesoin(lignes, commande) {
  return !lignes.every(l => checkIfLigneCanBeDeletedWithBesoin(l, commande));
}

export async function besoinsCommandeManager(commande) {
  commande.besoins = [];
  await store.dispatch('parametres/loadParametresInterne', [PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key]);
  const parametresInterne = store.getters['parametres/parametresInterne'];
  if (!parametresInterne(PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key)) return;

  const { items } = (await api.getAll({
    limit: NO_PAGINATION,
    query: { commandeId: commande.id },
  })).data.result;

  items.forEach(item => {
    item.deleted = false;
    item.selected = false;
    item.key = genererGuid();
    item.dateDepart = item.dateDepart ? new Date(item.dateDepart) : null;
    item.dateLivraison = item.dateLivraison ? new Date(item.dateLivraison) : null;
  });

  commande.besoins = items;
}
